module.exports = __webpack_public_path__ + "static/flags/CJ-c6460ba7d11ac2b2800bcab79b78dcb6.gif";